/* eslint-disable */
// prettier-ignore-start
export const litrals = {
  polygonpupText: 'Traffic information for this area is managed by:',
  polygonScotlandLayerName: 'Traffic Scotland',
  polygonTflLayerName: 'Transport for London',
  polygonTrafficWalesLayerName: 'Traffic Wales',
  tooltipText: 'Click for more information.',
  cookiesHeading: 'Your choice regarding cookies on this site',
  cookiesText: 'Text to be changed in a later release',
  searchBoxPlaceholder: 'Search by location or postcode',
  oiSearchBoxPlaceholder: 'Search',
  filterSearchBoxPlaceholder: 'Search Filters',
  noSearchResults: 'No search results found.',
  aboutSubscriberDataFeed: 'About subscriber data feed',
  aboutSubscriberDataFeedContentOne:
    'NTIS makes data available to subscribers for research purposes or for developers to include it in their own applications.',
  aboutSubscriberDataFeedContentTwo:
    'NTIS also makes data available to subscribers for research purposes or for developers to include it in their own applications.',
  configureDataFeed: 'Configure Data Feed',
  subscribeToDataFeed: 'To subscribe to a data feed please',
  dontHaveAccount: "or if you don't have an account please ",
  notConfiguredText: 'Not Configured',
  login: 'Log In',
  register: 'Register.',
  widgetModalTitle: 'Layer selection',
  widgetModalSubTitle1: 'Basemaps',
  azureMapCopyright: '©2020 TomTom',
  osMapCopyright1: '© Crown copyright and database rights 2021',
  osMapCopyright2: 'OS 0100030649. © 2020 TomTom',
  availableDataFeeds: 'Available Data Feeds',
  requireFurtherAssistance: 'If you require further assistance, please email ',
  clickHere: ' click here ',
  emailNTISTechnical: ' to email NTIS Technical Authority',
  dataFeedsDelivered: 'All data feeds are delivered in DATEX II v2.3 format.',
  back: 'back',
  configureText: 'Configure',
  acceptPolicyText: 'Accept Policy',
  declinePolicyText: 'Decline Policy',
  noAvailavleDatafeedErrorText:
    'There was an error retrieving the list of available data feeds, please go back and try again.',
  goback: 'Go back',
  noAvailavleDatafeedText:
    'No active data feeds available to configure at this time.',
  createUnplannedEvent: 'Create unplanned event',
  eventType: 'Event Type',
  event: 'Event',
  subtype: 'Subtype',
  identification: 'Identification',
  source: 'Source',
  logNumberText: 'Log Number',
  evenDetails: 'Event Details',
  laneCapacity: 'Lane Capacity',
  locationText: 'Location',
  locationButtonLabel: 'Locate on Map',
  eventServices: 'Event Services',
  services: 'Services',
  errorTitle: 'Page Not Found',
  errorText: 'The road ahead seems to be closed!',
  errorImgAlt: '404',
  vehicleTypeText: 'Vehicles Type',
  highPriority: 'High Priority',
  timetoclear: 'Time to clear',
  expectedtimetoclear: 'Expected time to clear',
  selectAll: 'Select all',
  addDataFeed: 'Add Data Feed',
  edit: 'Edit',
  yourConfiguredDataFeeds:
    'To make changes to your configured data feeds please click Edit.',
  disabledAllFeeds: 'Disable all feeds',
  currentSubscriptions: 'Current Subscriptions',
  saveText: 'Save',
  savedText: 'Saved',
  saveInternalUseText: 'Save Internal use',
  savedInternalUseText: 'Saved Internal use',
  confirmationText: 'Confirmation',
  noDataFeedsConfigured:
    'You have no data feeds configured, click on ‘Add Data Feed’ above to configure a data feed.',
  subscribedFeedsError:
    'Unable to retrieve your configured data feeds at this time. Please try again',
  retry: 'Retry',
  alertsList: 'Tasks List',
  alertSuccess: 'Changes to data feed have been successfully updated.',
  alertError: 'There was an error saving the changes, please try again.',
  alertSuccessDisabled: 'All data feeds have been successfully disabled.',
  alertSuccessActive: 'All data feeds have been successfully active.',
  maxDayHours: 24,
  maxMinutes: 60,
  plusOne: 'plusOne',
  minusOne: 'minusOne',
  minute: 'minute',
  hour: 'hour',
  operatorInterface: 'Operator Interface',
  subscriberPortal: 'Subscriber Portal',
  subscriberFeedback: 'Feedback',
  subscriberHelp: 'Help',
  subscriberHowToConfigure: 'How To Configure',
  subscriberWelcome: 'Subscriber portal',
  subscriberHowItWorks: 'How It Works',
  subscriberAvailableFeeds: 'Available Feeds',
  alertApiErrorText: 'There has been an issue, please try again',
  alertClearApiSuccessText: 'This Event has been cleared',
  alertClearApiFailureText: 'There has been an issue, please try again',
  clearEventText: 'Clear Event',
  clearEventSectionLabel: 'Confirm Event Clearance',
  clearEventTextHeading: 'Please Confirm Event Clearance',
  informationSource: 'Information Source ',
  unplannedEventText: 'Unplanned Event',
  aboutDownloadDataFeed: 'About',
  aboutDownloadDataFeedContent:
    'All downloads available here contain static configuration data defining the asset and network models.',
  download: 'Download',
  downloads: 'Downloads',
  allDataFeedsDelivered:
    'All data feeds are delivered in DATEX II v2.3 format.',
  unplanendEventUpdateApiSuccessText: 'This Event has been updated',
  unplannedEventUpdateApiFailureText:
    'This event has not been updated please try again',
  unplanendEventCreateApiSuccessText:
    'This event has been successfully created',
  unplannedEventCreateApiFailureText:
    'This event did not save, please try again',
  downloadToDataFeed: 'To download a data feed please ',
  feed: 'feed',
  removeFeed: 'Remove Feed',
  cancel: 'Cancel',
  removeFeedConfirmationContent: 'Are you sure you want to remove the',
  deleteFeedSuccess: 'Data feed has been successfully deleted.',
  deleteFeedError:
    'There was an error deleting the data feed, please try again.',
  confirmSubscription: 'Confirm Subscription',
  yourAccountInactiveFor12Months:
    'Your account has been inactive for over 12 months. If you do not complete this confirmation process by [date] then we will stop your data feed, delete your account and delete your personal information from our system.',
  wouldLikeToContinue:
    'Would you like to continue to receive NTIS data through this service? ',
  cancelSubscription: 'Cancel Subscription',
  continue: 'Continue',
  thankyouForConfirming:
    'Thank you for confirming your use of the service and your details.',
  youWillContinueToRecieveData:
    'You will continue to receive your data feed subscription, and will be asked to re-visit your subscription after 12 months of inactivity.',
  subscriptionConfirmed: 'Subscription Confirmed!',
  ifYoyNeedToChangePersonalDetails:
    'If you would like to change your personal details, please do so under your account section.',
  areYouSuretoCancelSubscription:
    'Are you sure you want to cancel your subscription? You will no longer have access to National Highways data feeds.',
  thanksForConfirmDontNeedSubscription:
    'Thank you for confirming that you no longer need to use our data feed. In order to protect your privacy, your data will now be permanently deleted from our records.',
  done: 'Done',
  subscriptionCancelled: 'Subscription Cancelled',
  brandImageAriaLabel: 'National Highways Logo',
  widgetButtonAriaLabel: 'Map layer options',
  recenterButtonAriaLabel: 'Centre map view button',
  searchIconAriaLabel: 'Search',
  searchFilterAriaLabel: 'search filter',
  searchWithInAriaLabel: 'search within filters',
  osMapLogoAriaLabel: 'OS Map Logo',
  azureMapLogoAriaLabel: 'Azure Map Logo',
  govmetricsFeedbackAriaLabel: 'Govmetrics feedback button',
  additionalInformationEventSectionHeading: 'Additional Information',
  additionalInformationLabel: 'Description',
  additionalInformationPlaceholder: 'Type here...',
  dropDownPlaceHolder: 'Please Select',
  otherOption: 'Other',
  otherInformationSourcePlaceholder:
    'Other Information Source (200 character limit)',
  notApplicableText: 'NA',
  returnToNormal: 'Return to normal',
  subscriberContactUS: 'Contact us',
};
